import React from 'react';
import { connect } from 'react-redux';
import { FormGroup, Label } from 'reactstrap';

class FontSelect extends React.PureComponent {
  handleChange = ({ target }) => {
    const { dispatch, id } = this.props;

    dispatch({
      type: 'EDIT_SITE_THEME',
      id,
      value: target.value,
    });
  };

  render() {
    const {
      id,
      children,
      values,
    } = this.props;

    return (
      <FormGroup className="text-capitalize font-large">
        <Label for={id} className="font-weight-bold">
          {children}
        </Label>
        <select
          className="form-control"
          id={id}
          value={values[id] || ''}
          onChange={this.handleChange}
        >
          <option value="'Merriweather', serif">Merriweather</option>
          <option value="'Roboto Slab', serif">Roboto Slab</option>
          <option value="'Source Sans Pro', sans-seri">Source Sans Pro</option>
          <option value="'Karbon', serif">Karbon</option>
        </select>
      </FormGroup>
    );
  }
}

const mapStateToProps = (store) => ({
  values: store.sites.values,
});

export default connect(mapStateToProps)(FontSelect);
